module.exports = __webpack_public_path__ + "media/3.4586f9f2.ogg";